// Vendor
import * as React from 'react';

// Internal
import { ChartFashionFootprint } from '@src/charts/ChartFashionFootprint';
import { IconArrow } from '@src/svg/IconArrow';
import { Quote } from '@src/components/Quote';
import { DEFAULT_SAL_PROPS, SAL_DELAY } from '@src/config/sal';
import { SPOT_GREEN } from '@thredup/styleguide/src/variables/colors';

// Images
import howDirtyBg from '@src/data/images/4d-howDirty.jpg';

// Styles
import styles from './styles.module.css';

const ConsumersHelp: React.FC = () => {
  return (
    <div className="tup-slide">
      <h1 {...DEFAULT_SAL_PROPS} className="max-w-xl">
        9 Things You Can Do to Reduce Your Fashion Footprint
      </h1>
      <h2 className="max-w-xl mb-4">
        Carbon emissions you’ll eliminate by making the following changes.
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="col-span-2">
          <div style={{ height: 550 }}>
            <ChartFashionFootprint />
          </div>
          <p className="tup-description">Annual carbon savings</p>
        </div>
        <div>
          <Quote
            author="– Elizabeth L. Cline, author of The Conscious Closet"
            quote="“As the momentum to solve the climate crisis builds, consumers are
          waking up to the realities of fashion’s impact on the environment.
          Shopping secondhand is one of the most effective ways for us to
          collectively lower our fashion footprint and make the most of the
          resources used to create these garments.”"
          />
          <div
            {...DEFAULT_SAL_PROPS}
            data-sal-delay={SAL_DELAY * 2}
            className="pt-12 p-4 pb-12 mt-4 text-center"
            style={{
              background: `url(${howDirtyBg})`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat'
            }}
          >
            <h2>How Dirty is Your Closet?</h2>
            <p>
              Take thredUP’s fashion footprint quiz to see your closet’s impact
              on the planet.
            </p>
            <a
              href="https://www.thredup.com/fashionfootprint"
              className="uppercase ml-4 mt-2 text-sm flex font-bold text-green items-center justify-center"
              target="_blank"
              rel="noopener noreferrer"
            >
              Take the quiz{' '}
              <IconArrow
                className={styles.arrow}
                direction="right"
                fill={SPOT_GREEN}
                height={20}
                width={30}
              />
            </a>
          </div>
        </div>
      </div>
      <p
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={SAL_DELAY * 3}
        className="tup-source text-center mt-8"
      >
        Green Story Inc. Environmental Study<sup>6</sup>
      </p>
    </div>
  );
};

export { ConsumersHelp };
